import { Event, User } from "@/types";
import { userHasRole } from "./roles";

export function shouldShowColumn(user: User, event: Event): boolean {
  // Return true if user is owner
  if (event.owner_id === user.id) {
    return true;
  }

  if (userHasRole(user.roles, ["l4a-trainee", "l4a-trainer"]) && event.level !== "Advanced Facilitator") {
    return false;
  }

  if (userHasRole(user.roles, ["facilitator-organisation"])) {
    return false;
  }

  // If trainer-organisation or l4a-trainer, and outside event organisation
  if (userHasRole(user.roles, ["trainer-organisation"]) && event.organisation_id !== user.organisation_id) {
    return false;
  }

  return true;
}
